import React from 'react';

const SignIcon = () => {
  return <span className="material-icons">draw</span>;
};

export default SignIcon;
